import { render, staticRenderFns } from "./ServiceContent.vue?vue&type=template&id=9205498c"
import script from "./ServiceContent.vue?vue&type=script&lang=js"
export * from "./ServiceContent.vue?vue&type=script&lang=js"
import style0 from "./ServiceContent.vue?vue&type=style&index=0&id=9205498c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports